import cn from 'clsx'

import { Button, Label, IconPen } from '@tracklib/kit'

import styles from './infobox.css'

type ItemProps = {
  label: string
  children?: JSX.Element | string
  audio?: boolean
}

const Item = ({ label, children, audio }: ItemProps): JSX.Element => (
  <div className={cn(styles.item, audio && styles.audioItem)}>
    <Label className={styles.label}>{label}</Label>
    {children || '-'}
  </div>
)

type InfoBoxProps = {
  userSongId: number
  modal?: string
  completed?: boolean
  showChildrenWhenNotCompleted?: boolean
  title: string
  subtitle: string
  children?: JSX.Element | JSX.Element[] | string | null
  disabled?: boolean
  step: number | JSX.Element
  bodyClassName?: string
  isLocked: boolean
  id?: string
  buttonText?: string
}

const InfoBox = ({
  userSongId,
  isLocked,
  modal,
  completed,
  showChildrenWhenNotCompleted,
  title,
  subtitle,
  children,
  disabled,
  step,
  bodyClassName,
  id,
  buttonText,
}: InfoBoxProps): JSX.Element => (
  <section className={styles.wrapper} id={id}>
    {!isLocked && (
      <div className={cn(styles.step, completed && styles.stepCompleted, disabled && styles.stepDisabled)}>
        <span>{step}</span>
      </div>
    )}
    <div className={cn(styles.body, bodyClassName)}>
      {title && <h2 className={cn(styles.title, isLocked && styles.titleActive)}>{title}</h2>}
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {(completed || showChildrenWhenNotCompleted) && children}
      {!isLocked && modal && buttonText && (
        <footer>
          {completed ? (
            <Button modal to={modal} query={{ userSongId }} disabled={disabled} variant="outline" className={styles.editButton}>
              <IconPen /> Edit
            </Button>
          ) : (
            <Button modal to={modal} query={{ userSongId }} disabled={disabled} className={styles.enterButton}>
              {buttonText}
            </Button>
          )}
        </footer>
      )}
    </div>
  </section>
)

InfoBox.Item = Item

export default InfoBox
